export const DOCUMENT_EXT_XLS = '.xls' as const;
export const DOCUMENT_EXT_XLSX = '.xlsx' as const;
export const DOCUMENT_EXT_CSV = '.csv' as const;
export const DOCUMENT_EXT_PDF = '.pdf' as const;
export const DOCUMENT_EXT_DOC = '.doc' as const;
export const DOCUMENT_EXT_DOCX = '.docx' as const;
export const DOCUMENT_EXT_JPG = '.jpg' as const;
export const DOCUMENT_EXT_JPEG = '.jpeg' as const;
export const DOCUMENT_EXT_PNG = '.png' as const;
export const DOCUMENT_EXT_TIFF = '.tiff' as const;
export const DOCUMENT_EXT_BMP = '.bmp' as const;
export const DOCUMENT_EXT_TXT = '.txt' as const;

export const DOCUMENT_ALLOWED_FILE_EXTENSIONS = [
    DOCUMENT_EXT_XLS,
    DOCUMENT_EXT_XLSX,
    DOCUMENT_EXT_CSV,
    DOCUMENT_EXT_PDF,
    DOCUMENT_EXT_DOC,
    DOCUMENT_EXT_DOCX,
    DOCUMENT_EXT_JPG,
    DOCUMENT_EXT_JPEG,
    DOCUMENT_EXT_PNG,
    DOCUMENT_EXT_TIFF,
    DOCUMENT_EXT_BMP,
    DOCUMENT_EXT_TXT,
] as const;

export type DocumentAllowedFileExtension =
    (typeof DOCUMENT_ALLOWED_FILE_EXTENSIONS)[number];

export const DOCUMENT_ALLOWED_FILE_ACCEPT =
    DOCUMENT_ALLOWED_FILE_EXTENSIONS.join(',');
